/** Homepage sections that encourage calling — Farenodex */
export const EXPERT_EDGE = {
  eyebrow: 'The human advantage',
  title: 'Why savvy travelers pick up the phone',
  subtitle:
    'Online search is a start. A real conversation is how you win on price, comfort, and peace of mind.',
  stats: [
    { value: '24/7', label: 'Live agents, every day' },
    { value: '<2 min', label: 'Typical time to answer' },
    { value: '50+', label: 'Airlines compared for you' },
    { value: '1 call', label: 'Flights, hotels, cars & more' },
  ],
  edges: [
    {
      icon: 'layers',
      title: 'Fares you won’t always see online',
      text: 'Partner and phone-only rates our agents can access while you stay on the line.',
    },
    {
      icon: 'route',
      title: 'Complex trips, simplified',
      text: 'Multi-city, mixed cabin, groups, and infants — we map the whole itinerary in one conversation.',
    },
    {
      icon: 'refresh',
      title: 'Changes without the runaround',
      text: 'Cancellations, credits, and schedule chaos — talk to someone who already knows your booking.',
    },
    {
      icon: 'compass',
      title: 'Answers before you pay',
      text: 'Baggage, seats, layovers, and timing — ask a pro so there are no surprises at the gate.',
    },
  ],
};

export const CALL_MOMENTS = {
  eyebrow: 'When a call wins',
  title: 'Six moments when one conversation beats a hundred clicks',
  subtitle: 'If any of these sound familiar, our team is built for exactly this.',
  moments: [
    {
      num: '01',
      title: 'The fare moved after you booked',
      text: 'We check reprice rules and airline policies — sometimes you save without starting over.',
    },
    {
      num: '02',
      title: 'Kids, seniors, or special needs',
      text: 'Seating, assistance, and family seating blocks are easier when a human requests them.',
    },
    {
      num: '03',
      title: 'Business travel changed overnight',
      text: 'Same-day swaps, flexible tickets, and backup routes — we work the phones so you don’t have to.',
    },
    {
      num: '04',
      title: 'A trip you’ve been planning for years',
      text: 'Honeymoons and milestone getaways deserve an expert who cares about the details.',
    },
    {
      num: '05',
      title: 'Refund or credit confusion',
      text: 'Vouchers, airline credits, and insurance questions are clearer with an agent who reads the fine print.',
    },
    {
      num: '06',
      title: 'You’re not sure what’s cheapest',
      text: 'Nearby airports, ±3 day flexibility, and bundle deals — we compare while you describe your plans.',
    },
  ],
  closing:
    'Save your screen time for inspiration. When it’s time to book or fix a trip, a specialist is ready around the clock.',
};
